import React from 'react'
import { Container } from 'src/components/common/Container'
import styled from 'styled-components'
import { Spinner } from 'src/components/common/Spinner'
import { Divider } from 'src/components/common/Divider'
import { GiftedCouponListSpace } from 'src/types/api'
import PurchaseHistoryCouponCard from 'src/components/common/PurchaseHistoryCouponCard'
import RenderIf from 'src/components/common/RenderIf'
import { Typography } from 'src/components/common/Typography'
import { Noto_subheading_r18 } from 'src/styles/fonts/NotoSansKrFonts'
import { GiftedCouponPageProps } from 'src/pages/GiftedCouponPage/index'

const GiftedCouponPageView = (props: GiftedCouponPageProps) => {
  const { giftedCouponNoMore, giftedCouponListData, setTarget } = props

  const isEmptyGiftedCouponList = giftedCouponListData?.length === 0

  return (
    <S.GiftedCouponWrap $option="flex_column">
      <S.GiftedCouponContentsContainer $option="flex_column">
        {isEmptyGiftedCouponList ? (
          <S.IsEmptyGiftedCouponContainer $option="flex_column" $row_gap="50px">
            <Typography $color="var(--black-30)" $fontStyle={Noto_subheading_r18}>
              선물한 쿠폰이 없습니다.
            </Typography>
          </S.IsEmptyGiftedCouponContainer>
        ) : (
          <Container $option="flex_column">
            {giftedCouponListData?.map(
              (couponInfo: GiftedCouponListSpace.GiftedCouponListInterface, index: number) => (
                <Container $option="flex_column" key={index}>
                  <Divider />
                  <PurchaseHistoryCouponCard {...props} couponInfo={couponInfo} type={'gift'} />
                </Container>
              ),
            )}
          </Container>
        )}
      </S.GiftedCouponContentsContainer>
      <RenderIf when={!giftedCouponNoMore}>
        <Spinner $color="var(--black-10)" ref={setTarget} $margin="50px auto 0 auto" />
      </RenderIf>
    </S.GiftedCouponWrap>
  )
}
export default GiftedCouponPageView

const S = {
  GiftedCouponWrap: styled(Container)`
    margin: 0 auto;
    padding-bottom: 30px;
    flex: 1;
    background-color: var(--black-4);
  `,
  IsEmptyGiftedCouponContainer: styled(Container)`
    flex: 1;
    align-items: center;
    justify-content: center;
    ${Noto_subheading_r18};
  `,
  GiftedCouponContentsContainer: styled(Container)`
    flex: 1;
    background-color: var(--black-4);
  `,
}
